import { CSSProperties } from "react";
import "./ServiceDetailExpertiseSection.css";
import Images from "../../../utility/imagePaths";
import {
  ExpertiseItemTypes,
  ServiceDetailExpertiseSectionType,
} from "../../../utility/types/generaTypes";
type ServiceDetailExpertiseSectionProps = {
  style?: CSSProperties;
  expertiseSection: ServiceDetailExpertiseSectionType;
};
const ServiceDetailExpertiseSection = ({
  style,
  expertiseSection,
}: ServiceDetailExpertiseSectionProps) => {
  return (
    <section style={style}>
      <div className="app_section">
        <div className="appSection_header_container">
          <h1 className="section_title">{expertiseSection.title}</h1>
          <p className="section_description">{expertiseSection.description}</p>
        </div>

        <div className="expertiseCards_container">
          {expertiseSection.data.map((expertise, index) => (
            <ExpertiseCard
              key={"ExpertiseCard" + index}
              expertise={expertise}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

type ExpertiseCardProps = {
  expertise: ExpertiseItemTypes;
};

const ExpertiseCard = ({ expertise }: ExpertiseCardProps) => {
  return (
    <div className="expertiseCard_container">
      <h2>{expertise.title}</h2>
      <p>{expertise.description}</p>
      <div className="expertise_bottom_container">
        {expertise.data.map((item, index) => (
          <div
            key={"expertise_points_container" + index}
            className="expertise_points_container"
          >
            <img src={Images.SVG_TICK_ICON} alt="tick" />
            <p>{item}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServiceDetailExpertiseSection;
